import { render, staticRenderFns } from "./ConfirmaCadastro.vue?vue&type=template&id=83bf34ee&"
import script from "./ConfirmaCadastro.vue?vue&type=script&lang=js&"
export * from "./ConfirmaCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports